import { reportShipmentsPerformanceTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SHIPMENTS_PERFORMANCE_FILTERS,
  RESTORE_INITIAL
} = reportShipmentsPerformanceTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportShipmentsPerformanceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SHIPMENTS_PERFORMANCE_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
